import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import flow from 'lodash/flow';
import mint from '@tunein/mint';
import Slider from 'material-ui/Slider';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import VolumeControlIcon from '../../shared/svgIcons/player/VolumeControlIcon';
import VolumeControlOffIcon from '../../shared/svgIcons/player/VolumeControlOffIcon';
import withParentHover from '../../../decorators/hovers/withParentHover';
import { prerollVolumeTheme } from '../../../styles/muiThemes';
import css from './preroll-controls.module.scss';

const styles = {
  innerSlider: {
    marginTop: 0,
    paddingTop: '3px',
    cursor: 'pointer',
    marginLeft: '12px',
  },
  visible: {
    visibility: 'visible',
  },
  hidden: {
    visibility: 'hidden',
  },
  container: {
    minimize: {
      paddingTop: '10px',
      right: '12px',
    },
    expanded: {
      paddingTop: '25px',
      right: '10px',
    },
  },
  volumeIcon: {
    minimized: {
      width: '15px',
      height: '15px',
    },
    expanded: {
      width: '20px',
      height: '20px',
    },
  },
};

const DEFAULT_VOLUME = 100;

export class PrerollVolumeController extends Component {
  static propTypes = {
    isHovering: PropTypes.bool.isRequired,
    isMinimized: PropTypes.bool.isRequired,
    volume: PropTypes.number,
  };

  state = {
    selectedVolume: 0,
  };

  onVolumeChange = (event, value) => {
    mint.volume(value);
    this.setState({ selectedVolume: value });
  };

  onMute = () => {
    mint.volume(0);
  };

  onUnMute = () => {
    mint.volume(this.state.selectedVolume || DEFAULT_VOLUME);
  };

  render() {
    const { volume, isHovering, isMinimized } = this.props;
    const volumeStyles = isMinimized
      ? styles.volumeIcon.minimized
      : styles.volumeIcon.expanded;
    return (
      <div>
        <div
          id="prerollPlayerVolume"
          data-testid="prerollPlayerVolume"
          data-volume={volume}
          style={
            isMinimized ? styles.container.minimize : styles.container.expanded
          }
          className={css.volumeContainer}
        >
          {volume ? (
            <VolumeControlIcon
              fillColor="white"
              viewBox="4 4 17 17"
              {...volumeStyles}
              onClick={this.onMute}
            />
          ) : (
            <VolumeControlOffIcon
              {...volumeStyles}
              fillColor="white"
              onClick={this.onUnMute}
            />
          )}
        </div>
        <MuiThemeProvider muiTheme={prerollVolumeTheme}>
          <Slider
            id="playerVolumeSlider"
            max={100}
            value={volume}
            className={css.prerollVolumeSlider}
            style={isHovering ? styles.visible : styles.hidden}
            sliderStyle={styles.innerSlider}
            axis="y"
            onChange={this.onVolumeChange}
            disableFocusRipple
          />
        </MuiThemeProvider>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    volume: state.preroll.volume,
  };
}

export default flow(
  connect(mapStateToProps),
  withParentHover,
)(PrerollVolumeController);
